import VueCircle from "vue2-circle-progress";
import filesize from "filesize";
import { baseUrl } from "../../../config.js";
import i18n from "../../../functions/i18next";

var timeoutHandle;
var totalsize = 0;

export default {
  /*
      Defines the data used by the component
    */

  components: { VueCircle },
  data() {
    return {
      files: [],
      link: "",
      copytekst: "Copy link",
      displayLink: false,
      successend: false,
      emails: "",
      transfer: 0,
      uploadPercentage: 1,
      uploadComplete: false,
      dragAndDropCapable: false,
      step: 1,
      errors: [],
      errorSending: false,
      company: this.$store.state.company,
      company_full: this.$store.state.company_full,
      maxSize: this.$store.state.company_full.plan.quick_size,
      maxSizeInGB: "",
      copied: false,
    };
  },
  created() {
    this.copytekst = i18n.t("common.copy_link");
    /*this.maxSizeInGB=filesize(this.maxSize).toString().toLowerCase().replace(/\s/g, "");*/
    this.maxSizeInGB = filesize(this.maxSize).toString().replace(/\s/g, "");
  },
  computed: {
    spaceRemaining: function () {
      let used = 0;
      for (var i = 0; i < this.files.length; i++) {
        used += this.files[i].size;
      }
      let diff = this.maxSize - used;
      diff = filesize(diff).toString().toLowerCase().replace(/\s/g, "");
      return diff;
    },
    emailsArray: function () {
      if (this.emails === "") {
        return [];
      }
      return this.emails.split(",");
    },
  },
  methods: {
    formatSize(key) {
      let size = this.files[key].size;
      size = filesize(size).toString().toLowerCase().replace(/\s/g, "");
      return size;
    },
    fileName(key, ext) {
      let file = this.files[key];
      let extention =
        "." + file.name.slice(((file.name.lastIndexOf(".") - 1) >>> 0) + 2);
      if (ext) {
        return extention;
      }
      return file.name.replace(extention, "");
    },
    addFiles() {
      this.$refs.files.click();
    },
    /*
          Trigger next step
        */
    saveFiles() {
      this.step = 2;
    },
    /*
          Submits all of the files to the server
        */
    submitFiles() {
      /*
              Initialize the form data
            */
      if (this.step == 2 && !this.uploadComplete) {
        let formData = new FormData();

        /*
                  Iteate over any file sent over appending) the files
                  to the form data.
                */
        for (var i = 0; i < this.files.length; i++) {
          let file = this.files[i];

          formData.append("files[" + i + "]", file);
        }

        /*
                  Make the request to the POST /multiple-files URL
                */

        this.$axios
          .post(baseUrl + "/makequicktransfer", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: function (progressEvent) {
              this.uploadPercentage = parseInt(
                Math.round((progressEvent.loaded * 100) / progressEvent.total)
              );
              this.$refs.completedCircle.updateProgress(this.uploadPercentage);
              if (this.uploadPercentage == 100) {
                this.uploadComplete = true;
              }
            }.bind(this),
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.status == 402) {
                alert(i18n.t("upload.upload_limit_reached"));
              }
            }
          })
          .then((response) => {
            this.link = response.data.link;
            this.transfer = response.data.transfer;
            this.step = 3;
          });
      }
    },

    /*
          Determines if the drag and drop functionality is in the window
        */
    determineDragAndDropCapable() {
      var div = document.createElement("div");
      return (
        ("draggable" in div || ("ondragstart" in div && "ondrop" in div)) &&
        "FormData" in window &&
        "FileReader" in window
      );
    },

    /*
          Handles a change on the file upload
        */
    handleFilesUpload() {
      this.filesUpload(this.$refs.files.files);
    },
    filesUpload(recieved) {
      let self = this;
      let err_filecount = false;
      let err_fileduplicate = false;
      let err_filesize = false;
      this.errors = [];
      for (let i = 0; i < recieved.length; i++) {
        let file = recieved[i];
        if (this.files.length < 200) {
          if (
            !this.files.filter(function (e) {
              return e.name === file.name;
            }).length > 0
          ) {
            totalsize += file.size;
            if (totalsize <= this.maxSize) {
              this.files.push(file);
            } else {
              err_filesize = true;
            }
          } else {
            err_fileduplicate = true;
          }
        } else {
          err_filecount = true;
        }
      }
      if (err_fileduplicate) {
        this.errors.push(i18n.t("update.upload_dubble_file"));
      }
      if (err_filecount) {
        this.errors.push(i18n.t("update.upload_count_limit"));
      }
      if (err_filesize) {
        this.errors.push(
          i18n.t("update.upload_size_limit", { size: this.maxSizeInGB })
        );
      }
      window.clearTimeout(timeoutHandle);
      timeoutHandle = window.setTimeout(function () {
        self.errors = [];
      }, 7500);
    },
    /*
          Removes a select file the user has uploaded
        */
    removeFile(key) {
      event.stopPropagation();
      var filelist = Array.from(this.files);
      filelist.splice(key, 1);
      this.files = filelist;
    },
    sendTransfer() {
      this.errorSending = false;
      let formData = new FormData();

      formData.append("emails", this.emails);
      formData.append("transfer", this.transfer);

      this.$axios.post(baseUrl + "/transfersend", formData).then((response) => {
        if (
          response.data.success == false &&
          response.data.msg == "email_invalid"
        ) {
          this.errorSending = true;
        }
        if (
          response.data.success == true &&
          response.data.msg == "transfer_send"
        ) {
          this.errorSending = false;
          this.successend = true;
        }
      });
    },
    transitionHandler() {
      this.submitFiles();
    },
  },
  mounted() {
    /*
        (re)trigger smooth reflow after a step is rendered
        */

    /*
        Determine if drag and drop functionality is capable in the browser
        */
    this.dragAndDropCapable = this.determineDragAndDropCapable();

    /*
        If drag and drop capable, then we continue to bind events to our elements.
        */
    if (this.dragAndDropCapable && this.$refs.fileform) {
      /*
            Listen to all of the drag events and bind an event listener to each
            for the fileform.
            */
      [
        "drag",
        "dragstart",
        "dragend",
        "dragover",
        "dragenter",
        "dragleave",
        "drop",
      ].forEach(
        function (evt) {
          /*
                For each event add an event listener that prevents the default action
                (opening the file in the browser) and stop the propagation of the event (so
                no other elements open the file in the browser)
                */
          this.$refs.fileform.addEventListener(
            evt,
            function (e) {
              e.preventDefault();
              e.stopPropagation();
            }.bind(this),
            false
          );
        }.bind(this)
      );

      /*
            Add an event listener for drop to the form
            */
      this.$refs.fileform.addEventListener(
        "drop",
        function (e) {
          this.filesUpload(e.dataTransfer.files);
        }.bind(this)
      );
    }
  },
};
